import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black border-t border-gray-800 mt-4">
      <div className="max-w-7xl mx-auto px-4 py-2">
        <div className="flex justify-between items-center">
          <Link to="/about" className="text-gray-600 hover:text-gray-400 transition-colors text-xs">
            About
          </Link>
          <div className="text-gray-700 text-xs">© 2025 Rewind Archive</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;